import { Disclaimer, Header } from "components";
import {
    REQUIRED_FIELDS,
    SSA_LOGIN_PAGE_URL_PATH,
    SSN_ROLE_OPTIONS,
    REGISTRATION_SUCCESSFUL_URL_PATH,
    REGISTRATION_PENDING_URL_PATH
} from "./constants";
import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import Toast from "react-bootstrap/Toast";
import ReactTooltip from "react-tooltip";
import { QuestionCircle } from "react-bootstrap-icons";
import "react-datepicker/dist/react-datepicker.css";
import {
    emailValidation,
    emailVerifyMatch,
    userNameValidation
} from "./validation";
import { analytics } from "./analytics";

const SSARegistration = () => {
    const [user, setUser] = useState({
        role: "",
        firstName: "",
        lastName: "",
        email: "",
        verifyEmail: "",
        id: "",
        consultantName: ""
    });
    const [errors, setErrors] = useState({
        email: "",
        verifyEmail: "",
        id: "",
        role: "",
        firstName: "",
        lastName: "",
        consultantName: ""
    });
    const [toastMessage, setToastMessage] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        analytics();
    }, []);

    useEffect(() => {
        if (user.role === "") {
            setSubmitDisabled(true);
            return;
        }

        // check if all fields are filled out
        const role = user.role;
        const requiredFields = REQUIRED_FIELDS[role];

        for (const element of requiredFields) {
            const fieldName = element;
            if (!user[fieldName]) {
                console.log(fieldName, user[fieldName]);
                setSubmitDisabled(true);
                return;
            }
        }
        // check if there is any error
        const errorFields = Object.keys(errors);
        for (const element of errorFields) {
            const fieldName = element;
            if (errors[fieldName] !== "") {
                setSubmitDisabled(true);
                return;
            }
        }
        setSubmitDisabled(false);
    }, [user, errors]);

    const handleChange = (e) => {
        const { name } = e.target;
        const { value } = e.target;
        const payload = { [name]: value };
        setUser((prev) => ({ ...prev, ...payload }));
    };

    const handleCancel = () => {
        document.location.href = SSA_LOGIN_PAGE_URL_PATH;
    };

    const handleBlur = async (e) => {
        const { name, value } = e.target;
        let errorMessage = "";

        if (name === "firstName") {
            errorMessage =
                value !== "" ? "" : "Please provide valid First Name";
        }

        if (name === "lastName") {
            errorMessage = value !== "" ? "" : "Please provide valid Last Name";
        }

        if (name === "consultantName") {
            errorMessage = value !== "" ? "" : "Please provide valid firm Name";
        }

        if (name === "email") {
            const emailValid = emailValidation(value);
            errorMessage = emailValid ? "" : "Enter valid email";
        }

        if (name === "verifyEmail") {
            errorMessage = emailVerifyMatch(user.email, value)
                ? ""
                : "Email addresses do not match";
        }

        if (name === "id") {
            const valid = userNameValidation(value);
            const tooShortOrLong = value.length < 6 || value.length > 8;
            const hasSpecialCharOrWhiteSpace = /\W|\D/g.test(value);
            if (valid) {
                errorMessage = "";
            } else if (tooShortOrLong) {
                errorMessage =
                    "Username must be between 6 and 8 characters long";
            } else if (hasSpecialCharOrWhiteSpace) {
                errorMessage =
                    "Username must not contain spaces or special characters";
            }
        }

        // if (user.role === "") {
        //     errorMessage = "Enter valid role";
        //     console.log("role value", user.role)
        //     // setSubmitDisabled(true);
        //     // return;
        // }

        // if (name === "role") {
        //     errorMessage = user.role !== "" ? "" : "Enter valid role";
        // }

        setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    };

    const formatPayload = () => {
        return {
            userRole: user.role,
            firstName: user.firstName,
            lastname: user.lastName,
            email: user.email.trim(),
            id: user.id,
            companyName: user.consultantName
        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = formatPayload();
        setSubmitting(true);
        try {
            const response = await axios({
                method: "POST",
                url: "/enroll/ssa/register",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload)
            });
            const result = response.data || {};
            if (result.data.flag === false) {
                document.location.href = REGISTRATION_PENDING_URL_PATH;
            } else {
                document.location.href = REGISTRATION_SUCCESSFUL_URL_PATH;
            }
        } catch (error) {
            setToastMessage(
                error.response?.data?.errorMessage ||
                    "Something went wrong. Please try again later."
            );
            window.scrollTo(0, 100);
        }
        setSubmitting(false);
    };

    const closeToast = () => {
        setToastMessage("");
    };

    return (
        <>
            {toastMessage !== "" && (
                <Toast onClose={closeToast} className="toast-cont">
                    <Toast.Header>
                        <strong className="me-auto">{toastMessage}</strong>
                    </Toast.Header>
                </Toast>
            )}
            <Header />
            <div className="mainMyAccount">
                <h1 className="heading" style={{ marginBottom: "2%" }}>
                    Consultant Registration
                </h1>
                <div className="subHeading" style={{ marginBottom: "3%" }}>
                    Consultants may register for access to the Pacific Life
                    website using the form below. You will be notified via email
                    once your account has been approved.
                </div>

                <Form>
                    <Row style={{ marginBottom: "2%" }}>
                        <Form.Label className="sub-title">
                            Please select your role
                        </Form.Label>
                        <Select
                            className="select"
                            placeholder="Select..."
                            name="role"
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "role",
                                        value: e.value
                                    }
                                })
                            }
                            options={SSN_ROLE_OPTIONS}
                            data-track="analytics"
                            onBlur={handleBlur}
                        />
                        <span className="validation-error-message">
                            {errors.role}
                        </span>
                    </Row>

                    {/* Personal Information section */}
                    <Row>
                        <Col sm={6}>
                            <label className="sub-title">
                                Personal Information
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                name="firstName"
                                value={user.firstName}
                                maxLength={25}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.firstName}
                            </span>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                name="lastName"
                                value={user.lastName}
                                maxLength={35}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.lastName}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <ReactTooltip multiline />
                            <Form.Label className="emailClass">
                                Email Address
                                <QuestionCircle
                                    className="iconClass"
                                    data-tip="The email address provided will be used to verify your account and for password reset."
                                    tabIndex="-1"
                                />
                            </Form.Label>
                            <Form.Control
                                name="email"
                                value={user.email}
                                maxLength={60}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.email}
                            </span>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Verify Email Address</Form.Label>
                            <Form.Control
                                name="verifyEmail"
                                value={user.verifyEmail}
                                maxLength={60}
                                onChange={handleChange}
                                onPaste={(e) => e.preventDefault()}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.verifyEmail}
                            </span>
                        </Col>
                    </Row>

                    {/* Identity Verification section */}
                    <Row>
                        <Col sm={6}>
                            <label className="sub-title">
                                Identity Verification
                                <QuestionCircle
                                    className="iconClass"
                                    data-tip="This is the full name of the firm your web profile should be associated with."
                                    tabIndex="-1"
                                />
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Label>Consultant Firm</Form.Label>
                            <Form.Control
                                name="consultantName"
                                value={user.consultantName}
                                maxLength={25}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.consultantName}
                            </span>
                        </Col>
                    </Row>

                    {/* Login Information section */}
                    <Row>
                        <Col sm={6}>
                            <label className="sub-title">
                                Login Information
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Label>
                                Create User Name
                                <QuestionCircle
                                    className="iconClass"
                                    data-tip="Create a unique User ID for website login."
                                    tabIndex="-1"
                                />
                            </Form.Label>
                            <Form.Control
                                name="id"
                                value={user.id}
                                // maxLength={25}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.id}
                            </span>
                        </Col>
                        <Col md={6}>
                            <Row>
                                <p className="sub-title" style={{ margin: 0 }}>
                                    Must be between 6 and 8 characters long
                                </p>
                                <p className="sub-title" style={{ margin: 0 }}>
                                    May contain letters and numbers
                                </p>
                                <p className="sub-title" style={{ margin: 0 }}>
                                    No spaces or special characters
                                </p>
                            </Row>
                        </Col>
                    </Row>

                    <div className="buttons-myaccount">
                        <Button
                            variant="secondary"
                            onClick={handleCancel}
                            onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                }
                            }}
                            data-track="analytics"
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handleSubmit}
                            data-track="analytics"
                            disabled={submitDisabled || submitting}
                        >
                            {submitting ? "Registering" : "Register"}
                        </Button>
                    </div>
                </Form>

                <div id="login" className="link-underline">
                    <a href={SSA_LOGIN_PAGE_URL_PATH}>
                        Already have an account?
                    </a>
                </div>
                <Disclaimer />
            </div>
        </>
    );
};

export default SSARegistration;
